<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra">
    <div class="row  ps-3">
      <div class="col pt-3 ">
        <p> <span class="fw-bold">Integrasi</span> - MITRS</p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5 ">
        <p class="text-muted">Sila pilih Jenis Pengemukaan Dokumen dan Tahun Taksiran. Klik <span class="fw-bold">Login</span></p>
      </div>
    </div>
    <div class="row pb-5">
      <div class="col-1 ms-5">
        <label>TIN : </label>
      </div>
      <div class="col-2 ms-5">
        <select class="form-select border-0 shadow" aria-label="Search type" [(ngModel)]="SearchTypeInput" [ngModelOptions]="{standalone: true}" (change)="onChangeIDType()">
          <option value="" selected>Jenis Carian</option>
          <option value="6">TIN (Selain No. Majikan)</option>
          <option value="7">TIN (Majikan)</option>
          <!--<option value="6">No. Pendaftaran (ROC)</option>-->
        </select>
      </div>
      <div class="col-2 ms-2">
        <input type="number" [(ngModel)]="TINInput" [ngModelOptions]="{standalone: true}" class="form-control border-0 shadow">
      </div>
      <div class="col-4">
        <div class="btn-toolbar d-flex justify-content-center">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Submit(SearchTypeInput,TINInput)">Hantar</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2 bg-white" role="button" (click)="Semula()">Semula</button>
          </div>
        </div>
      </div>
    </div>

    <div class="accordion px-5 pb-5" id="resultAcordion" *ngIf="SearchStatus">
      <div class="accordion-item border-0">
        <h2 class="accordion-header m-0" id="headingOne">
          <button class="accordion-button primary-colour text-black shadow rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            Butiran Carian
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse show bottom-page-shadow default-content-bg-colour rounded-bottom-extra" aria-labelledby="headingOne" data-bs-parent="#resultAcordion">
          <div class="accordion-body">
            <div class="row">
              <div class="col-2">
                <p>Pembayar Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-5">
                <p><strong>{{TaxpNameView}}</strong></p>
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <p>TIN</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col">
                <p><strong>{{ItGrpCdView}} {{TINView}}</strong></p>
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <p>LHDNM / Cawangan Khas</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-5">
                <p><strong>{{BranchNameView}}</strong></p>
              </div>
            </div>

            <div class="row pt-4" *ngIf="S80S82DescriptionStatus">
              <div class="col-12">
                <p>MITRS terdiri daripada dua (2) jenis modul pengemukaan dokumen seperti berikut:</p>
                <ul>
                  <li><span class="fw-bold">Dokumen Seksyen 82B</span> : Pengemukaan mandatori maklumat dan dokumen percukaian yang telah ditentukan di bawah seksyen 82B dalam tempoh 30 hari dari tarikh akhir pengemukaan borang nyata.</li>
                  <li><span class="fw-bold">Dokumen Seksyen 80 / Seksyen 81</span> : Pengemukaan dokumen tambahan audit yang diminta oleh pegawai LHDNM berdasarkan surat permohonan dokumen dan surat permohonan dokumen tambahan yang dikeluarkan kepada pembayar cukai yang diaudit.</li>
                </ul>
                <p>Pastikan pilihan jenis pengemukaan dokumen adalah betul.</p>
              </div>
            </div>

            <div class="row pt-4" *ngIf="S22EBS22DescriptionStatus">
              <div class="col-12">
                <p>MITRS terdiri daripada jenis modul pengemukaan dokumen seperti berikut:</p>
                <ul>
                  <li><span class="fw-bold">Dokumen Seksyen 22EB</span> : Pengemukaan mandatori maklumat dan dokumen percukaian yang telah ditentukan di bawah Seksyen 22EB dalam tempoh 30 hari dari tarikh akhir pengemukaan borang nyata.</li>
                  <!--<li><span class="fw-bold">Dokumen Seksyen 22</span> : Pengemukaan dokumen tambahan audit yang diminta oleh pegawai LHDNM berdasarkan surat permohonan dokumen dan surat permohonan dokumen tambahan yang dikeluarkan kepada pembayar cukai yang diaudit.</li>-->
                </ul>
                <p>Pastikan pilihan jenis pengemukaan dokumen adalah betul.</p>
              </div>
            </div>

            <div class="pt-4">
              <p>Senarai Borang</p>
              <!--<input #input type="text" (keyup)="applyFilter($event)" class="form-control w-25 mb-2 border-0 shadow" placeholder="Carian" aria-label="Carian" aria-describedby="basic-addon1">-->
            </div>
            <div>
              <table class="table table-borderless w-100">
                <thead>
                  <tr class="primary-colour text-center">
                    <th scope="col">Jenis Borang</th>
                    <th scope="col" *ngIf="SectionListStatus">Jenis Pengemukaan Dokumen</th>
                    <th scope="col" *ngIf="YearAssessmentListStatus">Tahun Taksiran</th>
                    <th scope="col">Ejen Cukai</th>
                    <th scope="col">Tindakan</th>
                  </tr>
                </thead>
                <tbody class="bg-white text-center pt-1">
                  <tr>
                    <!--<td>
            <select class="form-select border-0 shadow" [(ngModel)]="SectionInput" [ngModelOptions]="{standalone: true}">
              <option value="">Jenis Seksyen</option>
              <option value="S82">Seksyen 82B</option>
              <option value="S80">Seksyen 80 / 81</option>
            </select>
          </td>-->
                    <td>
                      <select class="form-select border-0 shadow" [(ngModel)]="FormTypeInput" [ngModelOptions]="{standalone: true}" (change)="ChangeFormTypeRegister(FormTypeInput)">
                        <option value="">Jenis Borang</option>
                        <option *ngFor="let res of FormTypeList" [value]="res.formName">e-{{res.formName}}</option>
                      </select>
                    </td>
                    <td *ngIf="SectionListStatus">
                      <select class="form-select border-0 shadow" [(ngModel)]="SectionInput" [ngModelOptions]="{standalone: true}" (change)="ChangeSectionRegister(SectionInput)">
                        <option value="">Jenis Pengemukaan Dokumen</option>
                        <option *ngFor="let res of SectionList" [value]="res.section">{{res.sectionDesc}}</option>
                      </select>
                    </td>
                    <td *ngIf="YearAssessmentListStatus">
                      <select class="form-select border-0 shadow" [(ngModel)]="YearAssessmentInput" [ngModelOptions]="{standalone: true}">
                        <option value="">Tahun Taksiran</option>
                        <option *ngFor="let res of YearAssessmentList" [value]="res.value">{{res.description}}</option>
                      </select>
                    </td>
                    <td>
                      <div>
                        <select class="form-select border-0 shadow" [(ngModel)]="AgentInput" [ngModelOptions]="{standalone: true}">
                          <option value="">Ejen Cukai</option>
                          <option *ngFor="let res of AgentList" [value]="res.taxAgentID">{{res.taxAgentName}}</option>
                        </select>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center">
                        <div class="btn-toolbar">
                          <div class="me-2">
                            <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="Login(FormTypeInput,TINView,AgentInput,YearAssessmentInput,SectionInput)">Login</button>
                          </div>
                          <div class="me-2">
                            <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="GetAcknowledment(SectionInput,FormTypeInput,YearAssessmentInput,TINView)">Semakan</button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

